import React from "react";
import {BaseInput} from "../BaseInput";
import {Dropdown} from "../Dropdown";

const PHONE_REGION_PREFIX = ['02', '03', '04', '05', '06', '07', '08', '09'];

export const PhoneInput = ({
  prefix,
  phone,
  onChangePrefix,
  onChangePhone,
}) => (
  <div className={"flex-row flex gap-x-2 items-center"}>
    <div className={"w-36"}>
      <Dropdown
        className={""}
        hasDiv={false}
        options={PHONE_REGION_PREFIX}
        dataSelected={prefix}
        disabled={false}
        onChange={e => onChangePrefix(e.target.value)}
        text="是否有管道"
      />
    </div>
    <div className={"mb-4"}>
      -
    </div>
    <BaseInput
      onChange={e => onChangePhone(e.target.value)}
      value={phone}
      placeholder="不用輸入「-」"
    />
  </div>
)
